import { BaseDto } from "@/shared/dtos/base-dto";

export class mapping_question extends BaseDto {
  public nombre_tabla!: string;
  public campo!: string;
  public display_text!: string;
}
